import { render, staticRenderFns } from "./ChildCategoryView.vue?vue&type=template&id=0b00d34a&"
import script from "./ChildCategoryView.vue?vue&type=script&lang=js&"
export * from "./ChildCategoryView.vue?vue&type=script&lang=js&"
import style0 from "./ChildCategoryView.vue?vue&type=style&index=0&id=0b00d34a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports